import { render, staticRenderFns } from "./mobile_device.vue?vue&type=template&id=ff852e0e&"
import script from "./mobile_device.vue?vue&type=script&lang=js&"
export * from "./mobile_device.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports